import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Grid, TableContainer, Table, TableHead, TableBody, TableRow, TableCell, } from '@mui/material';
import { formatMoneyAmount, weightFormat, kgFobPriceToLbFobPrice, feePer1kgToFeePer1lb, } from '../../utils/format';
import ButtonInCart from './ButtonInCart';
var mapper = function (result, orderedItem) {
    result[orderedItem.offer.id] = orderedItem.offer;
    return result;
};
var OrderShoppingCart = function (_a) {
    var orderedItemType = _a.orderedItemType, orderedItems = _a.orderedItems, simulatedOrderPrice = _a.simulatedOrderPrice, buttonTitle = _a.buttonTitle, onClickButton = _a.onClickButton, _b = _a.isUSRoaster, isUSRoaster = _b === void 0 ? false : _b;
    var t = useTranslation().t;
    var offersMap = orderedItems.reduce(mapper, {});
    var quantityWithWeight = function (item, isUSRoaster) {
        var _a = item, offerId = _a.offerId, quantity = _a.quantity;
        var orderedItem = offersMap[offerId];
        var weight = orderedItemType === 'TypicaStockItem'
            ? weightFormat(parseFloat(orderedItem.bagSize) * quantity)
            : weightFormat(parseFloat(orderedItem.minOrder) * quantity);
        return "".concat(quantity, " (").concat(weight, ")");
    };
    return (React.createElement(Box, null,
        React.createElement(TableContainer, { sx: { overflow: 'unset' } },
            React.createElement(Table, null,
                React.createElement(TableHead, null,
                    React.createElement(TableRow, null,
                        React.createElement(TableCell, { sx: {
                                backgroundColor: 'transparent',
                                color: 'rgba(255,255,255,.56)',
                                height: '48px',
                                pl: 2,
                                pr: 1,
                                borderBottom: function (theme) {
                                    return "1px solid ".concat(theme.customPalette.divider);
                                },
                                typography: function (theme) { return theme.customTypography.body4; },
                            } }, t('params.offer.lotNumber')),
                        React.createElement(TableCell, { align: "right", sx: {
                                backgroundColor: 'transparent',
                                color: 'rgba(255,255,255,.56)',
                                height: '48px',
                                px: {
                                    xs: 1,
                                    md: 2,
                                },
                                borderBottom: function (theme) {
                                    return "1px solid ".concat(theme.customPalette.divider);
                                },
                                typography: function (theme) { return theme.customTypography.body4; },
                            } }, "FOB"),
                        React.createElement(TableCell, { align: "right", sx: {
                                backgroundColor: 'transparent',
                                color: 'rgba(255,255,255,.56)',
                                height: '48px',
                                px: {
                                    xs: 1,
                                    md: 2,
                                },
                                borderBottom: function (theme) {
                                    return "1px solid ".concat(theme.customPalette.divider);
                                },
                                typography: function (theme) { return theme.customTypography.body4; },
                            } }, t('quantityWithWeight')),
                        React.createElement(TableCell, { align: "right", sx: {
                                backgroundColor: 'transparent',
                                color: 'rgba(255,255,255,.56)',
                                height: '48px',
                                px: {
                                    xs: 1,
                                    md: 2,
                                },
                                borderBottom: function (theme) {
                                    return "1px solid ".concat(theme.customPalette.divider);
                                },
                                typography: function (theme) { return theme.customTypography.body4; },
                            } }, t('params.orderPriceItem.totalFee')),
                        React.createElement(TableCell, { align: "right", sx: {
                                backgroundColor: 'transparent',
                                color: 'rgba(255,255,255,.56)',
                                height: '48px',
                                pl: 1,
                                pr: 2,
                                borderBottom: function (theme) {
                                    return "1px solid ".concat(theme.customPalette.divider);
                                },
                                typography: function (theme) { return theme.customTypography.body4; },
                            } }, t("params.orderPriceItem.".concat(isUSRoaster ? 'feePer1lb' : 'feePer1kg'))))),
                React.createElement(TableBody, null, simulatedOrderPrice.items.map(function (item) { return (React.createElement(TableRow, { key: item.offerId },
                    React.createElement(TableCell, { sx: {
                            backgroundColor: 'transparent',
                            color: '#FFF',
                            fontWeight: 500,
                            height: '48px',
                            pl: 2,
                            pr: 1,
                            py: 1,
                            typography: function (theme) { return theme.customTypography.body4; },
                        } }, offersMap[item.offerId].lotNumber),
                    React.createElement(TableCell, { align: "right", sx: {
                            backgroundColor: 'transparent',
                            color: '#FFF',
                            height: '48px',
                            px: {
                                xs: 1,
                                md: 2,
                            },
                            py: 1,
                            typography: function (theme) { return theme.customTypography.body4; },
                        } }, isUSRoaster
                        ? item.bidFobPriceUsdPerLb ||
                            kgFobPriceToLbFobPrice(Number(item.offerFobPrice))
                        : item.bidFobPrice || item.offerFobPrice),
                    React.createElement(TableCell, { align: "right", sx: {
                            backgroundColor: 'transparent',
                            color: '#FFF',
                            height: '48px',
                            px: {
                                xs: 1,
                                md: 2,
                            },
                            py: 1,
                            typography: function (theme) { return theme.customTypography.body4; },
                        } }, quantityWithWeight(item, isUSRoaster)),
                    React.createElement(TableCell, { align: "right", sx: {
                            backgroundColor: 'transparent',
                            color: '#FFF',
                            height: '48px',
                            px: {
                                xs: 1,
                                md: 2,
                            },
                            py: 1,
                            typography: function (theme) { return theme.customTypography.body4; },
                        } }, formatMoneyAmount(item.totalFee, simulatedOrderPrice.currency)),
                    React.createElement(TableCell, { align: "right", sx: {
                            backgroundColor: 'transparent',
                            color: '#FFF',
                            height: '48px',
                            pl: 1,
                            pr: 2,
                            py: 1,
                            typography: function (theme) { return theme.customTypography.body4; },
                        } }, formatMoneyAmount(isUSRoaster
                        ? feePer1kgToFeePer1lb(Number(item.feePer1kg))
                        : item.feePer1kg, simulatedOrderPrice.currency)))); })))),
        React.createElement(Grid, { container: true },
            React.createElement(Grid, { item: true, xs: 12, mx: 2, mb: 2 },
                React.createElement(ButtonInCart, { onClick: onClickButton, fullWidth: true }, buttonTitle)))));
};
export default OrderShoppingCart;
